export default __webpack_public_path__ + "static/2019_07-008b7dba88391d3a8ed8f07128717ca8.png";